export default __webpack_public_path__ + "static/media/course-sample1.c992c2ba.png";